module.exports = __webpack_public_path__ + "static/media/people-fill-primary.13e30049.svg";